// extracted by mini-css-extract-plugin
module.exports = {"header":"CompanyOfficial_header__1ZFye"};